<template>
  <div class="thank">
    <div class="thankhead">
      <h4>
        <span class="iconfont">&#xe722;</span>
        {{$t('shopping.thank_you')}}
        <i>{{order.billing_address.first_name}}</i>
      </h4>
      <p>
        {{$t('account.order')}}:
        <span>{{order.number}}</span>
      </p>
    </div>
    <div class="thankbody">
      <div class="ordersure">
        <div>
          <h5>{{$t('shopping.order_confirmed1')}}</h5>
          <p v-if="order.trackno">{{$t('shopping.order_confirmed2')}}</p>
          <p v-else>{{$t('shopping.order_confirmed')}}</p>
        </div>
        <div v-if="order.trackno">
          <h5>{{$t('shopping.tracking_number')}}</h5>
          <p>
            <a :href="'https://t.17track.net/en#nums='+order.trackno">{{order.trackno}}</a>
          </p>
        </div>
      </div>
      <!-- <div class="ordersure">
        <div>
          <h5>{{$t('shopping.order_updates1')}}</h5>
          <p>{{$t('shopping.order_updates2')}}</p>
        </div>
      </div> -->
      <div class="ordersure">
        <div>
          <h5>{{$t('shopping.customer_info')}}</h5>
          <ul class="Customerinformation clearfix">
            <li>
              <div>{{$t('shopping.contact_info')}}</div>
              <p>{{order.billing_address.email}}</p>
            </li>
            <li v-if="order.payment_method_title">
              <div>{{$t('shopping.payment_mothod')}}</div>
              <p>{{order.payment_method_title | pay_method_filt(availableCreditCardMethods,'Credit Card')}} - <v-currencysymbol></v-currencysymbol>{{order.order_total}}</p>
            </li>
            <li v-else>
              <div>{{$t('shopping.shipping_method')}}</div>
              <p v-if="order.shippings.length">{{order.shippings[0].order_item_name}}</p>
            </li>
            <li>
              <div>{{$t('shopping.shipping_address')}}</div>
              <p>{{order.shipping_address.first_name}} {{order.shipping_address.last_name}}</p>
              <p>{{order.shipping_address.address_1}} {{order.shipping_address.address_2}} {{order.shipping_address.city}}</p>
              <p>
                {{order.shipping_address.postcode}}
                <span
                  v-if="this.getstate(order.shipping_address.state,order.shipping_address.country,this.myService)"
                  v-html="this.getstate(order.shipping_address.state,order.shipping_address.country,this.myService)"
                ></span>
                <span v-else>{{order.shipping_address.state}} </span>
              </p>
              <p v-html="this.getcountry(order.shipping_address.country,this.myService)"></p>
              <p>{{order.shipping_address.phone}}</p>
            </li>
            <li>
              <div>{{$t('shopping.billing_address')}}</div>
              <p>{{order.billing_address.first_name}} {{order.billing_address.last_name}}</p>
              <p>{{order.billing_address.address_1}} {{order.billing_address.address_2}} {{order.billing_address.city}}</p>
              <p>
                {{order.billing_address.postcode}}
                <span
                  v-if="this.getstate(order.billing_address.state,order.billing_address.country,this.myService)"
                  v-html="this.getstate(order.billing_address.state,order.billing_address.country,this.myService)"
                ></span>
                <span v-else>{{order.billing_address.state}} </span>
              </p>
              <p v-html="this.getcountry(order.billing_address.country,this.myService)"></p>
              <p>{{order.billing_address.phone}}</p>
            </li>
            <li v-if="order.payment_method_title">
              <div>{{$t('shopping.shipping_method')}}</div>
              <p v-if="order.shippings.length" v-html="order.shippings[0].order_item_name"></p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="needhelp clearfix">
      <div>
        <span class="iconfont">&#xe725;</span>
        <a :href="'mailto:'+email">{{$t('shopping.need_help')}}</a>
      </div>
      <div>
        <a href="/">{{$t('shopping.continue_shipping')}}</a>
      </div>
    </div>

    <v-checkoutcommonfoot :blogname='blogname'></v-checkoutcommonfoot>
  </div>
</template>
<script>
import vCheckoutcommonfoot from "./checkoutcommonfoot";
import CountryStateJson from "../../../../assets/country_state.json";

export default {
  props: ["order", "email", "service","blogname"],
  data() {
    return {
      myService:[],
      availableCreditCardMethods: ["custom-worldpay","worldpay",'xborderpay','wc_asiabill_creditcard'],
    };
  },
  beforeMount(){
    this.myService=this.concatCounty(this.service,CountryStateJson);
  },
  mounted() {
    console.log(this.order);
  },
  filters:{
    pay_method_filt: (payment_method,list,res)=>{
      if(list.includes(payment_method)){
        return res
      }else{
        return payment_method;
      }
    }
  },
  components: {
    vCheckoutcommonfoot
  }
};
</script>
<style scoped lang='scss'>
.thank {
  .thankhead {
    h4 {
      font-size: 20px;
      span {
        color: #55c51d;
        font-size: 20px;
      }
    }
    p {
      font-size: 14px;
    }
  }
  .thankbody {
    .ordersure {
      border-radius: 5px;
      border: 1px solid #d9d9d9;
      padding: 20px;
      margin-top: 20px;
      & > :nth-child(1) {
        h5 {
          color: #333;
          font-size: 16px;
          margin-bottom: 8px;
        }
        p {
          color: #666;
          font-size: 14px;
        }
        .Customerinformation {
          padding: 0;
          list-style: none;
          li {
            width: 50%;
            float: left;
            padding-right: 20px;
            margin-top: 16px;
            div {
              font-size: 14px;
            }
            p {
              font-size: 12px;
              color: #666;
            }
          }
        }
      }
      & > :nth-child(2) {
        margin-top: 20px;
        border-top: 1px solid #d9d9d9;
        padding-top: 20px;
        h5 {
          color: #333;
          font-size: 14px;
          margin-bottom: 5px;
        }
        p {
          a {
            font-size: 14px;
            color: #013a8c;
            text-decoration: none;
          }
        }
      }
    }
  }
  .needhelp {
    padding-top: 20px;
    & > :nth-child(1) {
      padding: 10px 0;
      float: left;
      a {
        text-decoration: none;
        color: black;
      }
      span {
        font-size: 18px;
        font-weight: 600;
      }
    }
    & > :nth-child(2) {
      float: right;
      background: #0f88a7;
      border-radius: 5px;
      a {
        display: inline-block;
        color: white;
        padding: 20px;
        text-decoration: none;
      }
    }
    & > :nth-child(2):hover {
      opacity: 0.9;
    }
  }
}
@media screen and(max-width: 767px) {
  .thank {
    .thankbody {
      .ordersure {
        & > :nth-child(1) {
          .Customerinformation {
            li {
              float: none;
              width: 100%;
            }
          }
        }
      }
    }
    .needhelp {
      & > :nth-child(1) {
        float: none;
      }
      & > :nth-child(2) {
        text-align: center;
        float: none;
      }
    }
  }
}
* {
  font-style: normal;
  p {
    margin: 0;
  }
}
</style>